export default "__VITE_ASSET__jXd_MmqD__"